/**
 * 测量文本在容器中占多少行
 * @param text 被测量的文本
 * @param target 被测量文本将被放在哪个容器里面
 */
export function measureTextRows(text: string, target: HTMLDivElement | null) {
  if (target === null) {
    return 0;
  }

  const oneRow: Node = target.cloneNode();
  // @ts-ignore
  oneRow.innerHTML = text;
  // @ts-ignore
  oneRow.style.whiteSpace = 'nowrap';
  // @ts-ignore
  oneRow.style.overflow = 'hidden';
  target.parentNode?.appendChild(oneRow);
  // @ts-ignore
  const oneRowHeight = oneRow.clientHeight;
  target.parentNode?.removeChild(oneRow);

  const computedStyle = getComputedStyle(target);
  const { paddingTop, paddingBottom } = computedStyle;
  const top = parseInt(paddingTop, 10) || 0;
  const bottom = parseInt(paddingBottom, 10) || 0;

  const allRows = target.cloneNode();
  // @ts-ignore
  allRows.innerHTML = text;
  target.parentNode?.appendChild(allRows);
  // @ts-ignore
  const allRowsHeight = allRows.clientHeight;
  target.parentNode?.removeChild(allRows);

  const rowHeight = oneRowHeight - top - bottom;
  const rowsHeight = allRowsHeight - top - bottom;
  const rows = rowsHeight / rowHeight;

  return rows;
}
